import React from 'react';
import withAppState from '../../../mobx/withAppState'
import Pay from '../../../components/Pay';

const MiPayAtTablePayWrapper = props => {
  const handleNoClientToken = () => {
    props.popStep();
    props.setErrorModalMessage(
      'Could not contact payment provider.'
    );
  }

  return <Pay handleNoClientToken={handleNoClientToken} />
}

export default withAppState(MiPayAtTablePayWrapper,
  {
    mobXActions: ({
      popStep,
      goToStep,
      setErrorModalMessage,
    }) => ({
      popStep,
      goToStep,
      setErrorModalMessage,
    })
  }
);